import { Component, OnInit, input } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ETjansterModule } from '@vinnova/e-tjanster';
import { ToastModule } from '@vinnova/ui';
import { environment } from '../../environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: true,
  imports: [ETjansterModule, RouterOutlet, ToastModule],
})
export class LayoutComponent implements OnInit {
  readonly customContent = input(false);
  isProduction = false;
  hasError = false;

  ngOnInit() {
    this.isProduction = environment.production;
  }
}
